import React from 'react';

interface BoardSkeletonProps {
  /** Quantidade de colunas placeholder exibidas durante o carregamento. */
  columnCount?: number;
}

/**
 * Placeholder animado do Kanban enquanto os dados da empresa são carregados.
 * Mantém layout estável e reduz sensação de tela vazia pós-login.
 */
export const BoardSkeleton: React.FC<BoardSkeletonProps> = ({ columnCount = 6 }) => {
  return (
    <div
      className="flex gap-3 min-w-max h-full pb-3 items-stretch animate-pulse"
      aria-busy="true"
      aria-label="Carregando quadro de colaboradores"
    >
      {Array.from({ length: columnCount }, (_, columnIndex) => (
        <div key={columnIndex} className="flex flex-col shrink-0 w-[264px] gap-2 h-full">
          <div className="flex items-center justify-between px-2 py-1">
            <div className="h-3.5 bg-slate-200 rounded-md w-28" />
            <div className="size-5 bg-slate-100 rounded-full" />
          </div>
          <div className="flex-1 bg-slate-50 rounded-xl border border-slate-100 p-2 space-y-2 min-h-[200px]">
            {Array.from({ length: 4 }, (_, cardIndex) => (
              <div
                key={cardIndex}
                className="h-[72px] bg-slate-200/70 rounded-lg border border-slate-100"
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
